module.exports = __webpack_public_path__ + "static/stabi-292efd175af75326ce61314de8cfb45e.png";